import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <details>
  <summary>Add IPs to Firewall/WAF allowlists (recommended)</summary>
      <p>{`  For certain features like `}<a parentName="p" {...{
          "href": "/docs/toolbar/heatmaps"
        }}>{`heatmaps`}</a>{`, your Web Application Firewall (WAF) may be blocking PostHog’s requests to your site. Add these IP addresses to your WAF allowlist or rules to let PostHog access your site.`}</p>
      <p>{`  `}<strong parentName="p">{`EU`}</strong>{`: `}<inlineCode parentName="p">{`3.75.65.221`}</inlineCode>{`, `}<inlineCode parentName="p">{`18.197.246.42`}</inlineCode>{`, `}<inlineCode parentName="p">{`3.120.223.253`}</inlineCode></p>
      <p>{`  `}<strong parentName="p">{`US`}</strong>{`: `}<inlineCode parentName="p">{`44.205.89.55`}</inlineCode>{`, `}<inlineCode parentName="p">{`52.4.194.122`}</inlineCode>{`, `}<inlineCode parentName="p">{`44.208.188.173`}</inlineCode></p>
      <p>{`  These are public, stable IPs used by PostHog services (e.g., Celery tasks for snapshots).`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      